// extracted by css-extract-rspack-plugin
export default {"root":"root-wkMIkD","wrapper":"wrapper-TWSuGM","form":"form-VjHcd8","input":"input-z2ZDGf","lead":"lead-xaXR1Y","error":"error-DFYeZC"};